import { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import {Button, Modal, Box, Flex, Text, useMatchBreakpoints, IconButton, CopyIcon, useModal} from 'uikit'
import { ModalActions, ModalInput } from 'components/Modal'
import { useTranslation } from 'contexts/Localization'
import { copyText } from 'utils/copyText'
import {Trade} from "../sdk";
import {getTokenSlippage} from "../config";
import SettingsModal from "./Menu/GlobalSettings/SettingsModal";
import {useRouter} from "next/router";
import {AutoRow} from "./Layout/Row";
import Select from "./Select/Select";
import FormInput from "./FormInput";
import {getBep20Contract} from "../utils/contractHelpers";
import {getProviderOrSigner} from "../utils";
import BigNumber from "bignumber.js";

type TokenInfo = {
  name?: string
  symbol?: string
  decimals?: number
}

interface WithdrawModalProps {
  onConfirm?: () => void
  onDismiss?: () => void
}

const ContainerBox = styled(Box)`
  background: #222428;
  border-radius: 15px;
  border: 1px solid #2d2f35;
  width: 100%;
`
const ItemCard = styled.div`
  padding: 10px;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .laber{
    min-width: 250px;
  }
`
const Laber=styled.div`
padding: 10px;
`

const LabelWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
`

const TokensManageModal: React.FC<WithdrawModalProps> = ({ onDismiss,   }) => {
    const { t } = useTranslation()
    const router = useRouter()

    const [tokenType, setTokenType] = useState(1)
    const [address,setAddress] = useState('');

    const tokenTypeList = [
        { label: t('Liquidity providing token'), value: 1 },
        { label: t('Dividend token'), value: 2 },
        { label: t('Dividend buyback token'), value: 3 },
    ]

    const goToManage = () =>{
        onDismiss();
        router.push('/tokenManage?type='+tokenType+'&address='+address);
    }

    const handleSortOptionChange = (v) => {
        setTokenType(v.value)
    }

    const onChangeAddress = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value)
    }

    return (
    <Modal title={t('Manage Tokens')} onDismiss={onDismiss}>
        <Text fontSize="18px" color={'primary'}>
        </Text>
        <AutoRow justify="center" margin="1.2rem 0">
            <FormInput title={t('Token or LP Token address')} placeholder={t('Enter token or LP address')} isRequired={true} onChange={onChangeAddress}/>
            <LabelWrapper>
                <Text mb="8px" textTransform="uppercase">
                    {t('Type of token')+'*'}
                </Text>
                <Select style={{ borderRadius: '10px' }} options={tokenTypeList} onOptionChange={handleSortOptionChange} />
            </LabelWrapper>
        </AutoRow>
        <ModalActions>
        <Button variant="secondary" onClick={goToManage} width="100%">
          {t('View')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default TokensManageModal
